/* eslint-disable jsx-a11y/alt-text */
import { 
  Card, 
  Table, 
  Form, 
  Input,
  InputNumber,
  Select,
  Button,
  Space,
  Row,
  Col,
  message
} from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom"
import { PlusOutlined, MinusCircleOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons'
import EditDeliveryNo from '../OrderDetail/components/EditDeliveryNo'
import DeliveryInfo from '../OrderDetail/components/DeliveryInfo'
import service from '../../../@services'
import QueryString from "qs"
import './index.less'

const OrderSend = (props) => {
  const { search } = useLocation()
  let query = QueryString.parse(decodeURIComponent(search.replace("?", "")))
  const orderNo = query?.orderNo
  const deliveryWay = query?.deliveryWay

  const [loading, setLoading] = useState(false)
  const [editDeliveryNoVisible, setEditDeliveryNoVisible] = useState(false) // 编辑单号（弹窗）
  const [deliveryInfoVisible, setDeliveryInfoVisible] = useState(false) // 物流信息（弹窗）
  const [getMore, setgetMore] = useState(false) // 展示/折叠
  const [editDeliveryNoDetail, setEditDeliveryNoDetail] = useState({})
  const [deliveryInfoDetail, setDeliveryInfoDetail] = useState({})
  const [pager, setPager] = useState({
    pageIndex: 1,
    pageSize: 20,
  })
  const [formData, setFormData] = useState({
    pageIndex: 1,
    pageSize: 20,
  })
  const [baseInfo, setBaseInfo] = useState({})
  const [sendType, setSendType] = useState({})
  const [tableData, setTableData] = useState([])
  const columns = [
    {
      title: '商品信息',
      dataIndex: 'value',
      key: 'value',
      render: (text, record, index) => (
        <div className="info-box">
          <img src={record.pictureUrl ? record.pictureUrl : '/assets/error-img.png'} className='row-img' />
          <div className="right">
            <span className="right-title">{ record.productName ? record.productName : '--' }</span>
            <span className="right-type grey-text">{ record.spec ? record.spec : '--' }</span>
          </div>
        </div>
      )
    },
    {
      title: '数量',
      dataIndex: 'count',
      width: 140,
      render: (text, record, index) => (
        <span>x{ record.count ? record.count : '-' }</span>
      )
    },
    {
      title: '发货状态',
      dataIndex: 'status',
      width: 180
    },
    {
      title: '物流信息',
      dataIndex: 'info',
      width: 420,
      render: (text, record, index) => (
        <div>
          <div style={{ display: record.showMore ? 'none' : 'block' }}>
            {record.orderDeliveryInfoVoTop3 ? record.orderDeliveryInfoVoTop3.map((item, i) => {
              return<div className='delivery-item'>
                <div>包裹{ item.deliveryNumber }</div>
                <div 
                  className='company-name ml-10'>
                    { item.deliveryCompany && item.deliveryCompany == 'jingdong' ? '京东物流' : '' }
                </div>
                <div className='order-no ml-10'>{ item.deliveryCode }</div>
                <div className='btn ml-10' onClick={() => onDeliveryInfo(record, item, i)}>查询物流</div>
                <Button
                  type='info'
                  icon={<FormOutlined />}
                  onClick={() => onEditDelivery(record, item, i)}
                  className='ml-10'
                ></Button>
              </div>
            }) : '--'}
          </div>
          <div style={{ display: record.showMore ? 'block' : 'none' }}>
            {record.orderDeliveryInfoVo ? record.orderDeliveryInfoVo.map((item, i) => {
              return<div className='delivery-item'>
                <div>包裹{ item.deliveryNumber }</div>
                <div 
                  className='company-name ml-10'>
                    { item.deliveryCompany && item.deliveryCompany == 'jingdong' ? '京东物流' : '' }
                </div>
                <div className='order-no ml-10'>{ item.deliveryCode }</div>
                <div className='btn ml-10' onClick={() => onDeliveryInfo(record, item, i)}>查询物流</div>
                <Button
                  type='info'
                  icon={<FormOutlined />}
                  onClick={() => onEditDelivery(record, item, i)}
                  className='ml-10'
                ></Button>
              </div>
            }) : '--'}
          </div>

          <div 
            style={{ display: record.orderDeliveryInfoVo && record.orderDeliveryInfoVo.length >= 3 ? 'block' : 'none' }}>
            <div 
              className='more-btn' 
              onClick={() => showMoreRow(record, index, true)}
              style={{ display: record.showMore == false ? 'block' : 'none' }}
            >
              <span>更多</span>
            </div>
            <div 
              className='more-btn' 
              onClick={() => showMoreRow(record, index, false)}
              style={{ display: record.showMore == true ? 'block' : 'none' }}
            >
              <span>收起</span>
            </div>
          </div>
        </div>
      )
    },
  ];
  /* 包裹（列表） */
  const [packageList, setPackageList] = useState([])
  /* 物流公司列表 */
  const [companyDropdownList, setCompanyDropdownList] = useState([])
  /* 商品列表（全部） */
  const [productDropdownListFirst, setProductDropdownListFirst] = useState([])
  /* 商品列表（部分） */
  const [productDropdownList, setProductDropdownList] = useState([])

  /* 获取 详情 */
  const getDetail = async () => {
    const res = await service.orderSend.detail({ orderNo: orderNo })
    
    if(res) {
      let count = 0 // 商品总数
      let sendCount = 0 // 已发货商品数
      let sendCountAftersale  = 0 // 已发货商品数（售后状态）
      let presendCount = 0 // 待发货商品数
      let presendCountNoAftersale = 0 // 待发货商品数（排除售后状态）
      let deliveryNumArr = [] // 包裹序号列表

      if(res.details && res.details.length) {
        res.details.forEach(item => {
          let status = ''
          let countItem = item.count ? item.count : 0
          let sendCountItem = item.sendCount ? item.sendCount : 0

          item.showMore = false

          if(sendCountItem == 0) {
            status = '待发货'
          } else if(countItem == sendCountItem) {
            status = '已发货'
          } else if(sendCountItem < countItem) {
            status = sendCountItem + '/' + countItem + '已发货'
          }

          count += countItem
          sendCount += sendCountItem
          item.presendCount = countItem - sendCountItem
          item.status = status

          if(item.aftersaleStatus && (item.aftersaleStatus == 'un_audit' || item.aftersaleStatus == 'finish')) {
            sendCountAftersale++
          }

          // 包裹序号
          if(item.orderDeliveryInfoVo) {
            for(let key in item.orderDeliveryInfoVo) {
              if(item.orderDeliveryInfoVo[key].deliveryNumber) {
                deliveryNumArr.push(Number(item.orderDeliveryInfoVo[key].deliveryNumber))
              }
            }
            item.orderDeliveryInfoVoTop3 = item.orderDeliveryInfoVo.slice(0, 3)
          }
        })
        presendCount = count - sendCount
        presendCountNoAftersale = count - sendCountAftersale

        // 设置 包裹起始序号
        if(deliveryNumArr.length) {
          const maxNum = Math.max(...deliveryNumArr)
          const startNum = maxNum ? maxNum + 1 : 1
          initPackageList(startNum, presendCount)
        } else {
          initPackageList(1, presendCount)
        }
      }

      const baseInfoNew = {
        ...res,
        count,
        sendCount,
        presendCount,
        presendCountNoAftersale,
        sendType: null
      } 
      setBaseInfo(baseInfoNew)
      setTableData(res.details)
      createProductDropdownListFirst(res.details)
      createProductDropdownList(res.details)
    } else {
      initPackageList(1)
    }
  }
  /* 获取 物流公司（下拉列表） */
  const getCompanyDropdownList = async () => {
    service.delivery.companiesList().then(res => {
      if(res) {
        setCompanyDropdownList(res)
      }
    })
  }
  /* 初始化 包裹（列表） */
  const initPackageList = (startNum, presendCount) => {
    setSendType(1)
    setPackageList([
      {
        orderNo: baseInfo.orderNo,
        companyNo: 'jingdong', // 物流公司编号
        deliveryCode: null, // 物流单号
        deliveryCompany: '京东物流', // 物流公司名称
        deliveryNum: startNum ? startNum : 1,
        details: [
          {
            count: presendCount ? presendCount : 0,
            erpOrderDetailId: 'all', // 商品id
            presendCount: presendCount ? presendCount : 0
          }
        ]
      }
    ])
  }
  const onSubmit = async (val) => {
    if(!validate()) return
    setLoading(true)
    let list = packageList.map((item, index) => { return { 
        ...item,
        deliveryNum: index + 1
      } 
    })
    let data = {
      orderNo,
      sendType
    }

    if(deliveryWay && deliveryWay != 'null') {
      data.deliveryWay = deliveryWay
    }

    if(sendType == 1) {
      /* 全部发货 */
      data.orderDeliveryInfo = {
        companyNo: list[0].companyNo,
        deliveryCode: list[0].deliveryCode,
        deliveryCompany: list[0].deliveryCompany
      }
    } else {
      /* 部分发货 */
      data.goodsReqs = list
    }
    try {
      const res = await service.orderSend.deliver(data)
      if(res) {
        setLoading(false)
        message.success('发货成功')
        sessionStorage.setItem('delivery_refresh', '1')
        onBack()
      }
    } catch (error) {
      setLoading(false)
    }
  }
  const onBack = (val) => {
    props.history.push('/order-delivery/list')
  }
  /* 改变 物流公司 */
  const onChangeCompanyRow = (val, index) => {
    let list = packageList.map((element) => { return { ...element } })
    list[index].companyNo = val

    companyDropdownList.forEach(element => {
      if(element.companyNo == val) {
        list[index].deliveryCompany = element.deliveryCompany
        setPackageList(list);
      }
    })
  }
  /* 改变 商品（全部） */
  const onChangeProductFirstRow = (val, index, i) => {
    let list = packageList.map((item) => { return { ...item } })
    
    productDropdownListFirst.forEach(element => {
      if(element.id == val) {
        list[index].details[i].erpOrderDetailId = element.id
        if(val == 'all') {
          /* 选中 全部商品 */
          setSendType(1)
          list[index].details[i].presendCount = element.presendCount
          list[index].details[i].count = baseInfo.presendCount
          list[index].details = list[index].details.slice(0, 1)
          list = list.slice(0, 1)
        }else {
          /* 选中 某个商品 */
          setSendType(2)
          list[index].details[i].presendCount = element.presendCount
          list[index].details[i].count = list[index].details[i].presendCount
          list[index].details[i].aftersaleStatus = element.aftersaleStatus // 设置 商品售后状态
        }
      }
    })
    setPackageList(list);
  }
  /* 改变 商品（部分） */
  const onChangeProductRow = (val, index, i) => {
    let list = packageList.map((item) => { return { ...item } })
    productDropdownList.forEach(element => {
      if(element.id == val) {
        list[index].details[i].erpOrderDetailId = element.id
        list[index].details[i].presendCount = element.presendCount
        list[index].details[i].count = list[index].details[i].presendCount
        list[index].details[i].aftersaleStatus = element.aftersaleStatus // 设置 商品售后状态
      }
    })
    setPackageList(list);
  }
  /* 改变 物流单号 */
  const onChangeOrderNo = (val, index) => {
    let list = packageList.map((element) => { return { ...element } })
    val.target.value = val.target.value.trim()

    let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
    if(reg.test(val.target.value)) {
      message.warning('物流单号仅支持输入字母和数字')
    }

    list[index].deliveryCode = val.target.value;
    setPackageList(list);
  }
  /* 改变 商品数量 */
  const onChangeProductNumRow = (e, index, i) => {
    let list = packageList.map((element) => { return { ...element } })

    let reg = /^[0-9]+$/;
    if(!reg.test(e)) {
      message.warning('商品数量只能输入正整数')
    }

    list[index].details[i].count = e;
    setPackageList(list);
  }
  /* 添加 一行商品 */
  const onAddProductRow = (item, index) => {
    let list = packageList.map((element) => { return { ...element } })
    let lastProduct = list[index].details[list[index].details.length - 1]

    const obj = {
      count: 0,
      erpOrderDetailId: null,
      presendCount: 0
    }

    if(!list[index].details.length) {
      /* 没有商品 直接添加 */
      list[index].details.push(obj)
      setPackageList(list);
    } else {
      /* 有商品 进入校验 */
      if(!lastProduct.erpOrderDetailId) {
        message.warning('请先选择商品');
        return
      }

      if(!lastProduct.count) {
        message.warning('请先输入商品数量');
        return
      }

      let countReg = /^[0-9]+$/;
      if(!countReg.test(lastProduct.count)) {
        message.warning('商品数量仅支持输入正整数')
        return
      }

      list[index].details.push(obj)
      setPackageList(list)
    }
  }
  /* 添加 一行包裹 */
  const onAddPackageRow = () => {
    let list = packageList.map((element) => { return { ...element } })
    const lastRow = list[list.length - 1]

    if(!validatePackage(lastRow)) return

    list.push({
      companyNo: 'jingdong', // 物流公司编号
      deliveryCode: null, // 物流单号
      deliveryCompany: '京东物流', // 物流公司名称
      deliveryNum: lastRow.deliveryNum + 1,
      details: [
        {
          count: 0,
          erpOrderDetailId: 0, // 商品id
          presendCount: 0
        }
      ]
    })
    packageList && setPackageList(list)
  }
  /* 删除 一行包裹 */
  const onDelPackageRow = (index) => {
    if(packageList.length > 1) {
      let list = packageList.map((element) => { return { ...element } }) 
      list.splice(index, 1)
      setPackageList(list)
      message.success('移除包裹成功')
    } else {
      message.success('至少保留1条包裹')
    }
  }
  /* 删除 一行商品 */
  const onDelProductRow = (item, index, child, i) => {
    let list = packageList.map((element) => { return { ...element } })

    if(list[index].details.length > 1) {
      list[index].details.pop()
    }
    setPackageList(list)
  }
  /* 编辑 物流（弹窗） */
  const onEditDelivery = (record, item, index) => {
    setEditDeliveryNoDetail(item)
    setEditDeliveryNoVisible(true)
  }
  /* 查看 物流信息（弹窗） */
  const onDeliveryInfo = (record, item, index) => {
    setDeliveryInfoDetail(item)
    setDeliveryInfoVisible(true)
  }
  const createProductDropdownListFirst = (details) => {
    if(!details || !details.length) return

    let productDropdownListNew = [{
      id: 'all',
      productName: '全部商品',
      presendCount: baseInfo.presendCount
    }]
    details.forEach(element => {
      productDropdownListNew.push(element)
    })
    setProductDropdownListFirst(productDropdownListNew)
  }
  const createProductDropdownList = (details) => {
    if(!details || !details.length) return

    let productDropdownListNew = []
    details.forEach(element => {
      productDropdownListNew.push(element)
    })
    setProductDropdownList(productDropdownListNew)
  }
  const validate = () => {
    let flag = true

    let deliveryCodeArr = []
    packageList.forEach(element => {
      deliveryCodeArr.push(element.deliveryCode)

      if(!element.companyNo) {
        flag = false
        message.warning('请选择物流公司')
        return
      }

      if(!element.deliveryCode) {
        flag = false
        message.warning('请输入物流单号')
        return
      }else {
        let deliveryCodeReg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
        let regEn = /[`!@#$%^&*()_<>?:"{},.\/;'[\]]/im,
          regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

        if(deliveryCodeReg.test(element.deliveryCode)) {
          flag = false
          message.warning('物流单号仅支持输入字母和数字')
          return
        }

        if (regEn.test(element.deliveryCode) || regCn.test(element.deliveryCode)) {
          message.warning('内容不能包含标点符号')
          flag = false
          return;
        }
      }

      for(let key in element.details) {
        if(element.details[key].aftersaleStatus) {
          if(element.details[key].aftersaleStatus == 'un_audit') {
            flag = false
            message.warning('售后中的商品不允许操作发货')
            return
          }
          if(element.details[key].aftersaleStatus == 'finish') {
            flag = false
            message.warning('已售后的商品不允许操作发货')
            return
          }
        }

        if(!element.details[key].erpOrderDetailId) {
          flag = false
          message.warning('请选择商品')
          return
        }
        if(!element.details[key].count) {
          flag = false
          message.warning('请先输入商品数量');
          return
        } else {
          if(element.details[key].count == 0) {
            flag = false
            message.warning('商品数量不能为0')
            return
          }
    
          let countReg = /^[0-9]+$/;
          if(!countReg.test(element.details[key].count)) {
            flag = false
            message.warning('商品数量仅支持输入正整数')
            return
          }
        }
      }
    })

    let deliveryCodeUniquleArr = Array.from(new Set(deliveryCodeArr))
    if(deliveryCodeArr.length != deliveryCodeUniquleArr.length) {
      flag = false
      message.warning('物流单号不能重复')
      return
    }

    return flag
  }
  const validatePackage = (lastRow) => {
    let flag = true
    const { companyNo, deliveryCode } = lastRow

    if(!companyNo) {
      flag = false
      message.warning('请先选择物流公司');
      return
    }

    if(!deliveryCode) {
      flag = false
      message.warning('请先输入物流单号');
      return
    } else {
      let deliveryCodeReg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
      let regEn = /[`!@#$%^&*()_<>?:"{},.\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
      if(deliveryCodeReg.test(deliveryCode)) {
        flag = false
        message.warning('物流单号仅支持输入字母和数字')
        return
      }

      if (regEn.test(deliveryCode) || regCn.test(deliveryCode)) {
        flag = false
        message.warning('内容不能包含标点符号')
        return;
      }
    }

    if(lastRow.details && lastRow.details.length) {
      lastRow.details.forEach(element => {
        console.log('element =>', element);
        if(!element.erpOrderDetailId) {
          flag = false
          message.warning('请选择商品');
          return
        }

        if(!element.count) {
          flag = false
          message.warning('请先输入商品数量');
          return
        } else {
          if(element.count == 0) {
            flag = false
            message.warning('商品数量不能为0')
            return
          }
    
          let countReg = /^[0-9]+$/;
          if(!countReg.test(element.count)) {
            flag = false
            message.warning('商品数量仅支持输入正整数')
            return
          }
        }
      })
    }
    return flag
  }
  // 是否展示 发货按钮
  const showSubmitBtn = () => {
    let flag = true

    if(packageList.length > baseInfo.count) {
      flag = false
      message.warning('包裹数量不能大于商品总数')
      return
    }

    return flag
  }
  // 是否展示 添加包裹按钮
  const showAddPackageBtn = (item, index) => {
    let flag = true

    if(item.details[0].erpOrderDetailId == 'all') {
      flag = false
      return
    }
    if(index != packageList.length -1) {
      flag = false
      return
    }
    if(baseInfo.count <= 1) {
      flag = false
      return
    }

    return flag
  }
  // 是否展示 添加关联商品按钮
  const showAddProductBtn = (item) => {
    let flag = true

    // 商品待发货总数（排除售后状态） > 1 才显示关联商品按钮
    if(baseInfo.presendCountNoAftersale <= 1) {
      flag = false
      return
    }
    if(!item.details) {
      flag = false
      return
    }
    if(item.details[0].erpOrderDetailId == 'all') {
      flag = false
      return
    }
    if(baseInfo.count <= 1) {
      flag = false
      return
    }

    return flag
  }
  // 展开/折叠
  function showMoreRow(record, index, isShow) {
    let tableDataTemp = tableData.map((element) => { return { ...element } })

    tableDataTemp[index].showMore = isShow
    setTableData(tableDataTemp)
  }
  const actionsFooter = (
    <Space align='end'>
      <Button onClick={onBack}>取消</Button>
      <Button
        type='primary'
        loading={loading}
        htmlType='submit'
        onClick={onSubmit}
        style={{ display: showSubmitBtn() ? "block" : "none" }}
      >
        发货
      </Button>
    </Space>
  )

  useEffect(() => {
    getDetail()
    getCompanyDropdownList()
  }, [pager, formData])
  return (
    <div className="order-send-page">
      <Card className="order-info-wrapper">
        <div className="title">订单信息</div>
        <div className="count-box">
          <span className="red-text">{ baseInfo.count }</span>件商品,
          <span className="red-text ml-10">{ baseInfo.presendCount }</span>件待发货
        </div>

        <Table 
          size='middle' 
          bordered 
          dataSource={tableData} 
          columns={columns} 
          rowKey={(record) => record.id}
          className="table" 
          pagination={ false } 
        />

        <div className="receive-box">
          <span className="grey-text">收货信息</span>
          <div className="detail ml-10">
            <span>{ baseInfo.receiverName }</span>
            <span className='ml-10'>{ baseInfo.receiverPhone || '--' }</span>
            <span className='ml-10'>{ baseInfo.receiverAddrName || '--' }</span>
            <span className='ml-10'>{ baseInfo.receiverAddr || '--' }</span>
          </div>
        </div>
      </Card>

      <Card className="logistics-wrapper" actions={[actionsFooter]}>
        <div className="title">物流服务</div>
          {packageList.map((item, index) => {
            return<div className="package-item" key={index}>
              <div className="left">
              <img src='/assets/package.png' className='package-img' />  
                <span>包裹{ item.deliveryNum }</span>
              </div>
              <div className="right">
                <div className='form'>
                  <Row gutter={24} className='row'>
                    <div className='row-header' style={{ display: index > 0 ? 'flex' : 'none' }}>
                      <div className='del-btn-box' onClick={() => onDelPackageRow(index)}>
                        <DeleteOutlined />
                        <span>移除包裹</span>
                      </div>
                    </div>
                    <div className='row-wrapper mt-10'>
                      <div className='label-box'>
                        <img src="/assets/required.png" className='required-img' />
                        <span>物流公司</span>
                      </div>
                      <div className='content-box'>
                        <Select 
                          placeholder="请选择物流公司" 
                          onChange={(val) => onChangeCompanyRow(val, index)} 
                          value={ item.companyNo }
                          className='form-item'
                        >
                          {companyDropdownList.map((element, k) => (
                            <Select.Option value={ element.companyNo } key={ k }>
                              { element.deliveryCompany }
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </Row>
                  <Row gutter={24} className='row'>
                    <div className='row-wrapper'>
                      <div className='label-box'>
                        <img src="/assets/required.png" className='required-img' />
                        <span>物流单号</span>
                      </div>
                      <div className='content-box'>
                        <Input 
                          placeholder="请输入物流单号" 
                          value={item.deliveryCode} 
                          onChange={(val) => onChangeOrderNo(val, index)} 
                          className='form-item'
                        />
                      </div>
                    </div>
                  </Row>
                  <Row gutter={24} className='row'>
                    {item.details && item.details.map((child, i) => {
                        return<div className='row-wrapper row-wrapper-item'>
                          <div className='label-box'>
                            <img src="/assets/required.png" className='required-img' />
                            <span>商品{ i + 1 }</span>
                          </div>
                          <div className='content-box'>
                            <Select 
                              placeholder="请选择商品" 
                              value={child.erpOrderDetailId} 
                              onChange={(val) => onChangeProductFirstRow(val, index, i)}
                              className='form-item'
                              style={{ display: (index == 0 && i == 0) ? "block" : "none" }}
                            >
                              {productDropdownListFirst.map((element, k) => (
                                element.presendCount !== 0 ? <Select.Option  value={ element.id } key={ k }>
                                  { element.productName }
                                </Select.Option> : null
                              ))}
                            </Select>
                            <Select 
                              placeholder="请选择商品" 
                              value={child.erpOrderDetailId} 
                              onChange={(val) => onChangeProductRow(val, index, i)}
                              className='form-item'
                              style={{ display: i > 0 ? "block" : index > 0 ? 'block' : "none" }}
                            >
                              {productDropdownList.map((element, k) => (
                                element.presendCount !== 0 ? <Select.Option  value={ element.id } key={ k }>
                                  { element.productName }
                                </Select.Option> : null
                              ))}
                            </Select>
                          </div>
                          <div className='other-box'>
                            <div className="operator">x</div>
                             <InputNumber 
                              value={child.count}  
                              min={0} 
                              onChange={(e) => onChangeProductNumRow(e, index, i)} 
                              disabled={ child.erpOrderDetailId == 'all' ? true : false }
                              className='product-input'
                            />
                            <Button
                              type='info'
                              icon={<MinusCircleOutlined />}
                              onClick={() => onDelProductRow(item, index, child, i)}
                              style={{ display: i == 0 ? "none" : "block" }}
                              className="product-btn"
                            >
                            </Button>
                          </div>
                        </div>
                      }
                    )}
                  </Row>
                  <Row 
                    gutter={24} 
                    className='row' 
                    style={{ display: showAddProductBtn(item) ? "block" : "none" }}
                  >
                    <div className='row-wrapper'>
                      <div className='label-box'></div>
                        <div className='content-box'>
                          <Button
                            type='info'
                            icon={<PlusOutlined />}
                            onClick={() => onAddProductRow(item, index)}
                          >添加关联商品
                          </Button>
                        </div>
                    </div>
                  </Row>
                </div>
                <div 
                  className='bottom-btn-box' 
                  style={{ display: showAddPackageBtn(item, index) ? "block" : "none" }}

                >
                  <Button
                    type='info'
                    icon={<PlusOutlined />}
                    onClick={onAddPackageRow}
                  >添加包裹
                  </Button>
                </div>
              </div>
            </div>
          })}
      </Card>

      <EditDeliveryNo
        visible={editDeliveryNoVisible}
        onClose={() => setEditDeliveryNoVisible(false)}
        onGetDetail={() => getDetail()}
        detail={editDeliveryNoDetail}
      />
      <DeliveryInfo
        visible={deliveryInfoVisible}
        onClose={() => setDeliveryInfoVisible(false)}
        detail={deliveryInfoDetail}
        baseInfo={baseInfo}
      />
    </div>
  )
}
export default OrderSend
